<template>
  <v-row align="center" justify="center" class="mt-6">
    <v-card max-width="75%" width="500" flat color="background">
      <!-- <v-row align="center" justify="center">
        <v-img
          v-if="!videoFlag"
          src="../assets/video.svg"
          class="ma-1 puntero"
          @click="playVideo()"
        ></v-img>

        <iframe
          v-if="videoFlag"
          width="500"
          height="300"
          src="https://www.youtube.com/embed/7_kqxkpkQpc"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </v-row> -->
      <v-row class="d-flex align-center justify-center margin">
        <h1 class="PideGas ma-6">Tenemos más Servicios disponibles en nuestra App! Descárgala <a target="_blank" href="http://okboy.app.link/ZRYV3YJZefb">aquí</a></h1>
        <!-- <a href="">
          <img src=""> -->
      </v-row>
      <br>
    </v-card>
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      videoFlag: false,
    };
  },
  methods: {
    playVideo() {
      this.videoFlag = true;
    },
  },
};
</script>

<style scoped>
.PideGas {
  width: 364px;
  height: 75px;
  font-size: 32px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.13;
  letter-spacing: -0.02px;
  color: #303034;
  text-align: center;
}
.puntero {
  cursor: pointer;
}
.margin{
  margin: 25px 0px 30px 0px;
}
</style>